import Tooltip from '@material-ui/core/Tooltip';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import withGS from '../../core/withGShoc';
import PropTypes from 'prop-types';
import React from 'react';

class TaxonomySelectorMenuItem extends React.Component {

    render() {

        const { data, defaultLang, id, displayWorkflow } = this.props;

        const label = data.title && data.title[defaultLang] ?
            data.title[defaultLang]
            :
            data.title && data.title["und"] ?
                data.title && data.title["und"]
                :
                id;

        const labelSpan = <span style={{ width: '95%', overflow: 'hidden' }} data-test="taxonomy-title">
            <span>{label}</span>
            {
                data.activateWorkflow && displayWorkflow &&
                <span style={{ marginLeft: 6, float: 'right', marginRight: 6 }}>
                    <Tooltip title="Workflow is activated">
                        <AssignmentTurnedInIcon data-test="workflow-activated" style={{ verticalAlign: 'middle', fontSize: '1rem'}} />
                    </Tooltip>
                </span>
            }</span>;

        return (
            labelSpan
        );
    }
}

TaxonomySelectorMenuItem.defaultProps = {
    displayWorkflow: false
};

TaxonomySelectorMenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    displayWorkflow: PropTypes.bool,
    data: PropTypes.object.isRequired,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withGS(TaxonomySelectorMenuItem, ["ALL"], null, {});